import CustomContextPad from "./CustomContextPad";
import CustomPalette from "./CustomPalette";
import CustomRenderer from "./CustomRenderer";
import "bpmn-js/dist/assets/diagram-js.css";
import "bpmn-js/dist/assets/bpmn-font/css/bpmn.css";
import "bpmn-js/dist/assets/bpmn-font/css/bpmn-embedded.css";

// eslint-disable-next-line
export default {
  __init__: ["customContextPad", "customPalette", "customRenderer"],
  customContextPad: ["type", CustomContextPad],
  customPalette: ["type", CustomPalette],
  customRenderer: ["type", CustomRenderer],
};
